import { render, staticRenderFns } from "./ModalRegistrarNecessidade.vue?vue&type=template&id=a663be58&scoped=true"
import script from "./ModalRegistrarNecessidade.vue?vue&type=script&lang=js"
export * from "./ModalRegistrarNecessidade.vue?vue&type=script&lang=js"
import style0 from "./ModalRegistrarNecessidade.vue?vue&type=style&index=0&id=a663be58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a663be58",
  null
  
)

export default component.exports